// src/hooks/useEventSalesStatus.js
import { useMemo } from 'react';
import { checkIsSalesNotStarted, checkIsSalesEnded, checkIsEventEnded } from '../utils/eventDateUtils';

export function useEventSalesStatus(event) {
  const isSalesNotStarted = useMemo(() => checkIsSalesNotStarted(event), [event]);
  const isSalesEnded = useMemo(() => checkIsSalesEnded(event), [event]);
  const isEventEnded = useMemo(() => checkIsEventEnded(event), [event]);

  return { isSalesNotStarted, isSalesEnded, isEventEnded };
}
